import { render, staticRenderFns } from "./PromoPlanDefault.vue?vue&type=template&id=1226655b&scoped=true&"
import script from "./PromoPlanDefault.vue?vue&type=script&lang=js&"
export * from "./PromoPlanDefault.vue?vue&type=script&lang=js&"
import style0 from "./PromoPlanDefault.vue?vue&type=style&index=0&id=1226655b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1226655b",
  null
  
)

export default component.exports